import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AuthenticationFacade } from '../+state';
import { SoftCheckResponse } from '../models';

// This is used only on the root page, in case we have the token in cache but it is expired we want to redirect to login
@Injectable()
export class TokenValidationGuard implements CanActivate {
  constructor(private authFacade: AuthenticationFacade) {}

  public canActivate(): Observable<boolean> {
      this.authFacade.softCheck();
      return this.authFacade.softCheckResponse$.pipe(
        filter((softCheckResponse) => softCheckResponse != null),
        map((softCheckResponse) => softCheckResponse === SoftCheckResponse.Valid)
      );
    }
}
